// src/components/ui/Loader/Loader.jsx
import React from 'react';

export const Loader = ({ size = 'md', fullScreen = false, text = 'Загрузка...' }) => {
  const sizes = {
    sm: { width: '24px', height: '24px', borderWidth: '2px' },
    md: { width: '40px', height: '40px', borderWidth: '3px' },
    lg: { width: '56px', height: '56px', borderWidth: '4px' },
  };

  const spinnerStyle = {
    width: sizes[size].width,
    height: sizes[size].height,
    border: `${sizes[size].borderWidth} solid rgb(var(--c-border))`,
    borderTop: `${sizes[size].borderWidth} solid rgb(var(--c-accent))`,
    borderRadius: '50%',
    animation: 'spin 0.8s linear infinite',
  };

  const containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '16px',
    ...(fullScreen && {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(255,255,255,0.8)',
      zIndex: 9999,
    }),
  };

  return (
    <div style={containerStyle}>
      <div style={spinnerStyle} />
      {text && (
        <span style={{
          fontSize: '14px',
          color: 'rgb(var(--c-text-secondary))',
          fontWeight: 300,
        }}>
          {text}
        </span>
      )}
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};